import React from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';
import i18n from 'i18next';
import 'react-image-crop/dist/ReactCrop.css';
import { CloseIcon, CheckIcon } from '@edusynch/edusynch-svg-icons';
import * as S from './CropArea.styles';

export const CropArea = ({
  imageAsFile,
  imageSrc,
  customCrop,
  onCropCancel,
  onCropSave,
}) => {
  const [crop, setCrop] = React.useState(customCrop);
  const imageRef = React.useRef(null);

  const handleCropSave = (event) => {
    event.preventDefault();

    const image = imageRef.current;
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    canvas.toBlob(
      (blob) => {
        const imageFile = new File([blob], imageAsFile.name, {
          lastModified: Date.now(),
          type: imageAsFile.type,
        });

        onCropSave(imageFile);
      },
      'image/jpeg',
      1
    );
  };

  return (
    <S.CropModalContainer>
      <S.CropContent>
        <ReactCrop
          src={imageSrc}
          crop={crop}
          onChange={(newCrop) => setCrop(newCrop)}
          onImageLoaded={(image) => (imageRef.current = image)}
          disabled={false}
        />
      </S.CropContent>

      <S.Container>
        <S.CropButtonContainer onClick={onCropCancel}>
          <S.CropButton type="cancel">
            <CloseIcon type="small" />
          </S.CropButton>
          <S.CropText>{i18n.t('commons.buttons.cancel-button')}</S.CropText>
        </S.CropButtonContainer>

        <S.CropButtonContainer onClick={handleCropSave}>
          <S.CropButton type="save">
            <CheckIcon type="small" />
          </S.CropButton>
          <S.CropText>{i18n.t('commons.buttons.save-crop-button')}</S.CropText>
        </S.CropButtonContainer>
      </S.Container>
    </S.CropModalContainer>
  );
};

CropArea.defaultProps = {
  customCrop: {
    unit: '%',
    aspect: 1 / 1,
    width: 50,
    x: 25,
    y: 25,
  },
};

CropArea.propTypes = {
  imageAsFile: PropTypes.object.isRequired,
  imageSrc: PropTypes.string.isRequired,
  customCrop: PropTypes.object.isRequired,
  onCropCancel: PropTypes.func.isRequired,
  onCropSave: PropTypes.func.isRequired,
};
